import React, { Component } from 'react';
import { connect } from 'react-redux';
import { browserHistory } from 'react-router';
import { asyncConnect } from 'redux-connect';
import { bindActionCreators } from 'redux';
import _ from 'lodash';
import ApplyCSS from '../../../../../components/ApplyCSS';
import VerificationForm from './verificationForm';
import InputButton from '../../../../../components/ZUILib/InputButton';
import DepositForm from './depositForm';
import UserCardBankForm from './UserCardBankForm';
import MonederoForm from './MonederoForm';
import * as typeActions from '../../actions';
import * as labelsActions from '../../../../../components/labels/actions';
import { getEventSummaryInfo } from '../../../../eventManagement/page/GiftList/actions';
import commonUtil from '../../../../../utils/commonUtil';
import StepBar from '../../../../../components/ZUILib/StepBar';
import ModalPopover from '../../../../../components/ZUILib/ModalPopover';
import AppEvents from '../../../../App/AppEvents';
import MultiStepProgressBar from '../../../../../components/MultiStepProgressBar/MultiStepProgressBar';
import OtpCode from '../RetiroAnticipado/OtpCode';
import { setGiftListTransferenceStatementTab } from '../../../../eventManagement/page/GiftList/actions';

// const d = { isEmployee: 'false', migratedEvent: 'false', isClosingGiftEligible: 'true', links: [], transferenceOptions: { bonusAmount: '1212', transferableAmount: '308.79', bonusPercentage: '12.0', availableWalletsInfo: [{ accountName: 'Monedero Mesa de Regalos', accountId: '100002', commissionFee: '1.0' }, { accountName: 'Monedero Tarjeta Liverpool', accountId: '100005', commissionFee: '2.0' }, { accountName: 'Monedero Liverpool Premium Card', accountId: '100006', commissionFee: '3.0' }], transferenceMethods: [{ code: '0', name: 'Monedero' }], savedWalletsInfo: [] }, status: { errorMessage: '', errorCode: '', status: 'success' }, currTime: 1529328177720 };
const channel = commonUtil.getChannel();
const constChannels = commonUtil.getClientConstForChannel();
const applicationRoutes = commonUtil.getApplicationRoutes();
const { isLablesLoaded, loadLables } = labelsActions;

const pageName = 'closureTransference';
const { getTransferenceOptions, calculateCommision, initiateEventCloseProcess } = typeActions;

import { getEventThresholdGiftDetails } from '../../../../eventManagement/page/GiftList/actions';

@asyncConnect([{
  promise: ({ store: { dispatch, getState } }) => {
    if (!isLablesLoaded(getState())) {
      return dispatch(loadLables());
    }
    return undefined;
  },
},
])
@connect(store => ({
  content: store.targetterContent.data,
  lables: store.labels.data,
  error: store.labels.error,
  loading: store.labels.loading,
  extraData: store.labels.extraData,
}),
  { labelsActions, setGiftListTransferenceStatementTab })


class Closure extends Component {
  constructor(props) {
    super(props);
    this.eventId = (this.props.params && this.props.params.eventID) ? this.props.params.eventID : '';
    this.eventOwnerId = this.props.location && this.props.location.state ? this.props.location.state.eventOwnerId : null;
    this.type = 'closure';
    this.openEvent = this.props.location && this.props.location.state ? this.props.location.state.openEvent : false;
    this.userName = this.props.user.data && this.props.user.data.result ? (this.props.user.data.result.firstName + ' ' + this.props.user.data.result.lastName) : '';
    this.reqData = {};
    this.pageSendToVerificationForm = null;
    this.isCombinadoExists = false;
    this.state = {
      transferenceData: null,
      transferenceDataError: null,
      submitTransferenceData: null,
      depositFormWap: true,
      verificationFormWap: false,
      userCardBankFormWap: false,
      monederoFormWap: false,
      page: 1,
      closureStepBarInfo: {
        currentStep: 1,
        total: 3,
      },
    };
    this.monederoStepBarInfo = {
      currentStep: 1,
      total: 2,
    };
    this.combinadoStepBarInfo = {
      currentStep: 1,
      total: 3,
    };
  }
  UNSAFE_componentWillMount() {
    if (this.eventOwnerId) {
      const activeDigitalWallet = (this.props.user.data.result.digitalWalletAccNumber !== 'undefined'
      && this.props.user.data.result.digitalWalletAccNumber != ''
      && !_.isEmpty(this.props.user.data.result.digitalWalletAccNumber)) ? 'true' : 'false';

      getTransferenceOptions(this.eventId, this.eventOwnerId, this.type, 'false', activeDigitalWallet)
        .then((res) => {
          if (res.body.status.status === 'success') {
            this.setState({ transferenceData: res.body });
          } else {
            this.setState({ transferenceDataError: res.body.status && res.body.status.errorMessage });
          }
        });
    }

    this.props.getEventThresholdGiftDetails(this.eventId);
  }

  redirectToGiftListPage = () => {
    this.props.setGiftListTransferenceStatementTab(true);
    browserHistory.push(commonUtil.routeTo(applicationRoutes.giftList, { eventID: this.eventId }));
  }

  componentDidMount() {
    commonUtil.clearBrowserHistoryState(commonUtil.getRouteByParameter(applicationRoutes.closureTransference,
      {
        eventID: this.eventId,
      },
     ));

    if (this.eventOwnerId) {
      if (channel === constChannels.WAP) {
        this.wapBackButtonEvent = AppEvents.subscribe(AppEvents.EVENT_REGISTER.WAP_BACK_BUTTON_CLICKED);
        if (this.wapBackButtonEvent) {
          AppEvents.publish(this.wapBackButtonEvent, [() => {
            /*eslint-disable*/
            this.pageSendToVerificationForm === null ? 
            this.redirectToGiftListPage() :
              this.onBackClick(this.pageSendToVerificationForm);
          }]);
          /*eslint-enable*/
        }
      }
      commonUtil.addTransition();
    } else {
      // If no this.eventOwnerId redirect to Gift List Statement Page
      this.redirectToGiftListPage();
    }
  }

  submitTransferenceDataFunction = (submitTransferenceParams) => {
    if (submitTransferenceParams) {
      if (submitTransferenceParams.walletType !== 'undefined' && !submitTransferenceParams.paymentMode) {
        let walletType = '';
        const totalAmountForCommission = (+submitTransferenceParams.walletOrEmployeeCardAmount + +submitTransferenceParams.bonusAmount).toString();
        /* eslint-disable */
        if (this.state.transferenceData.isEmployee.toString() === 'true') {
          walletType = '';
        } else {
          if (submitTransferenceParams.walletOrEmployeeIdentifierId) {
            walletType = '0';
          } else {
            walletType = submitTransferenceParams.walletType;
          }
        }
        /* eslint-enable */
        // calculateCommision(this.eventId, '', walletType, totalAmountForCommission, submitTransferenceParams.walletOrEmployeeIdentifierId)
        //   .then((data) => {
        //     if (data.body.status.status === 'success') {
        //       const transactionInfo = data.body.transactionInfo;
              // if (transactionInfo.commissionToWallet) {
                this.setState({
                  submitTransferenceData: {
                    ...this.reqData,
                    ...submitTransferenceParams,
                    walletUserName: submitTransferenceParams.walletUserName ? submitTransferenceParams.walletUserName : this.userName,
                    totalAmount_View: totalAmountForCommission,
                    totalAmount: totalAmountForCommission,
                    commissionValue: ".00",
                    walletCommissionAmount: ".00",
                  },
                });
              // }
              /*eslint-disable*/

              if (this.isCombinadoExists) {
                this.combinadoStepBarInfo = {
                  currentStep: 4,
                  total: 4,
                };
                this.pageSendToVerificationForm = 'VerificationForm';
                if (channel === constChannels.WAP) {
                  this.setState({ depositFormWap: false, userCardBankFormWap: false, monederoFormWap: false, verificationFormWap: true });
                  commonUtil.goToTop();
                } else {
                  this.acc._goToPanel(3);
                }
              } else {
                this.monederoStepBarInfo = {
                  currentStep: 2,
                  total: 2,
                };
                this.pageSendToVerificationForm = 'VerificationForm';
                if (channel === constChannels.WAP) {
                  this.setState({ depositFormWap: false, userCardBankFormWap: false, monederoFormWap: false, verificationFormWap: true })
                  commonUtil.goToTop();
                }
              }

          //   }
          // })
          // .catch((e) => {
          //   console.log(e); // console required
          // });
      } else if (submitTransferenceParams.paymentMode === '4') {  // Combinado case
        this.setState({
          submitTransferenceData: {
            ...this.reqData,
            ...submitTransferenceParams,
          },
        });
        if (+submitTransferenceParams.cardOrBankAmount > 0) {
          if (channel === constChannels.WAP) {
            this.combinadoStepBarInfo = {
              currentStep: 2,
              total: 4,
            };
            this.pageSendToVerificationForm = 'UserCardBankForm';
            this.setState({ depositFormWap: false, userCardBankFormWap: true, monederoFormWap: false, verificationFormWap: false });
            commonUtil.goToTop();
          } else {
            this.acc._next()
          }
        } else {
          if (channel === constChannels.WAP) {
            this.combinadoStepBarInfo = {
              currentStep: 3,
              total: 4,
            };
            this.pageSendToVerificationForm = 'MonederoForm';
            this.setState({ depositFormWap: false, userCardBankFormWap: false, monederoFormWap: true, verificationFormWap: false });
            commonUtil.goToTop();
          } else {
            this.acc._goToPanel(2);
          }
        }
      } else if (submitTransferenceParams.paymentMode === 'UserCardBankForm') {
        this.setState({
          submitTransferenceData: {
            ...this.state.submitTransferenceData,
            ...submitTransferenceParams,
            cardBankUserName: submitTransferenceParams.accountName ? submitTransferenceParams.accountName : this.userName,
          },
        });
        if (channel === constChannels.WAP) {
          this.combinadoStepBarInfo = {
            currentStep: 3,
            total: 4,
          };
          this.pageSendToVerificationForm = 'MonederoForm';
          this.setState({ depositFormWap: false, userCardBankFormWap: false, monederoFormWap: true, verificationFormWap: false });
          commonUtil.goToTop();
        } else {
          this.acc._next();
        }
      } else if (submitTransferenceParams.paymentMode === 'MonederoForm') {
        this.setState({
          submitTransferenceData: {
            ...this.state.submitTransferenceData,
            ...submitTransferenceParams,
            walletOrEmployeeCardAmount: this.state.submitTransferenceData.walletOrEmployeeCardAmount,
            bonusAmount: this.state.submitTransferenceData.bonusAmount,
          },
        });
        if (channel === constChannels.WAP) {
          this.combinadoStepBarInfo = {
            currentStep: 4,
            total: 4,
          };
          this.pageSendToVerificationForm = 'VerificationForm';
          this.setState({ depositFormWap: false, userCardBankFormWap: false, monederoFormWap: false, verificationFormWap: true })
          commonUtil.goToTop();
        } else {
          this.nextPage(2)
        }
      } else if (submitTransferenceParams.paymentMode === 'ClosingGift') {
        this.setState({
          submitTransferenceData: {
            ...this.reqData,
            ...this.state.submitTransferenceData,
            ...submitTransferenceParams,
          },
        });
        if (channel === constChannels.WAP) {
          this.monederoStepBarInfo = {
            currentStep: 2,
            total: 2,
          };
          this.pageSendToVerificationForm = 'VerificationForm';
          this.setState({ depositFormWap: false, userCardBankFormWap: false, monederoFormWap: false, verificationFormWap: true })
          commonUtil.goToTop();
        } else {
          this.nextPage(2)
        }
      }
      /*eslint-enable*/
    } else {
      this.setState({ submitTransferenceData: this.reqData });
    }
  }

  onCerrarMesaSinOtpClick = () => {
    initiateEventCloseProcess(this.props.params.eventID).then((response) => {
      if (response.body.status && response.body.status.status === 'success') {
        this.redirectToGiftListPage();
      } else {
        this.setState({ transferenceDataError: response.body && response.body.errorMessage });
      }
    });
  }

  onBackClick = (loadFrom) => {
    this.pageSendToVerificationForm = null;
    /*eslint-disable*/
    if (loadFrom === 'MonederoForm') {
      if (+this.state.submitTransferenceData.cardOrBankAmount > 0) {
        if (channel === constChannels.WAP) {
          this.pageSendToVerificationForm = 'UserCardBankForm';
          this.combinadoStepBarInfo = { currentStep: 2, total: 4 };
          this.setState({ depositFormWap: false, userCardBankFormWap: true, monederoFormWap: false, verificationFormWap: false });
          commonUtil.goToTop();
        } else {
          this.acc._prev();
        }
      } else {
        if (channel === constChannels.WAP) {
          this.combinadoStepBarInfo = { currentStep: 1, total: 4 };
          this.setState({ depositFormWap: true, userCardBankFormWap: false, monederoFormWap: false, verificationFormWap: false });
          commonUtil.goToTop();
        } else {
          this.acc._goToPanel(0);
        }
      }
    } else if (loadFrom === 'UserCardBankForm') {
      if (channel === constChannels.WAP) {
        this.combinadoStepBarInfo = { currentStep: 1, total: 4 };
        this.setState({ depositFormWap: true, userCardBankFormWap: false, monederoFormWap: false, verificationFormWap: false });
        commonUtil.goToTop();
      } else {
        this.acc._prev();
      }
    } else if (loadFrom === 'VerificationForm') {
      if (this.state.submitTransferenceData.walletType && !this.state.submitTransferenceData.paymentMode) {
        if (channel === constChannels.WAP) {
          this.isCombinadoExists ? this.combinadoStepBarInfo = { currentStep: 1, total: 4 } : this.monederoStepBarInfo = { currentStep: 1, total: 2 };
          this.setState({ depositFormWap: true, userCardBankFormWap: false, monederoFormWap: false, verificationFormWap: false });
          commonUtil.goToTop();
        } else {
          this.acc._goToPanel(0)
        }
      } else {
        if (this.state.submitTransferenceData.paymentMode && this.state.submitTransferenceData.paymentMode === 'ClosingGift') {
          if (channel === constChannels.WAP) {
            this.setState({ depositFormWap: true, userCardBankFormWap: false, monederoFormWap: false, verificationFormWap: false });
            commonUtil.goToTop();
          } else {
            this.acc._prev();
          }
        } else {
          if (channel === constChannels.WAP) {
            this.isCombinadoExists ? this.combinadoStepBarInfo = { currentStep: 3, total: 4 } : this.monederoStepBarInfo = { currentStep: 1, total: 2 };
            this.pageSendToVerificationForm = 'MonederoForm';
            this.setState({ depositFormWap: false, userCardBankFormWap: false, monederoFormWap: true, verificationFormWap: false })
            commonUtil.goToTop();
          } else {
            this.acc._prev();
          }
        }
      }
    }
    /*eslint-enable*/
  }

  nextPage = (page) => {
    this.setState(
      { page,
        closureStepBarInfo: {
          currentStep: page,
          total: 3,
        },
      });
  }

  render() {
    const { transferenceData } = this.state;
    if (transferenceData) {
      this.reqData = {
        eventId: this.eventId,
        eventOwnerId: this.eventOwnerId,
        type: this.type,
        transferDate: transferenceData.currTime,
      };
      if (transferenceData.transferenceOptions && transferenceData.transferenceOptions.transferenceMethods) {
        this.isCombinadoExists = _.find(transferenceData.transferenceOptions.transferenceMethods, { code: '4' });
      }
    }

    const Aceptar = {
      id: 'closeModal',
      type: 'button',
      value: 'Aceptar',
      autoFocus: false,
      style: 'btnPrimary size-Full',
    };

    const cerrarMesaSinOtp = {
      type: 'button',
      value: 'Cerrar Mesa',
      id: 'CerrarMesaSinTP',
      autoFocus: false,
      style: 'btnPrimary size-Full',
      onClickHandler: this.onCerrarMesaSinOtpClick,
    };

    return (
      <React.Fragment>
        {!_.isEmpty(this.props.lables) ?
          <div className="giftRegistryClosure">
            {
              channel === constChannels.WAP ?
                <div className="row" style={{ margin: '0 1%' }}>
                  <ApplyCSS pageName={pageName + 'WAP'} />
                  <h4 style={{ paddingTop: '5%' }}>Cierre de Mesa de Regalos</h4>
                  {
                    !_.isEmpty(transferenceData && this.props.user.data) ?
                    (transferenceData.transferenceOptions &&
                      (+transferenceData.transferenceOptions.bonusAmount > 0 || 
                      +transferenceData.transferenceOptions.transferableAmount > 0)
                    ) ?
                      <React.Fragment>
                        <StepBar info={this.state.closureStepBarInfo} customWidth={'32%'} customStepsCss={' customSteps'} isAddSpacer={true} />
                        {
                          this.state.page === 1 ?
                            <DepositForm
                              onBackClick={this.onBackClick}
                              user={this.props.user}
                              submitTransferenceDataFunction={this.submitTransferenceDataFunction}
                              transference={transferenceData}
                              eventId={this.eventId}
                              lables={this.props.lables}
                              nextPage={this.nextPage}
                              setGiftListTransferenceStatementTab={this.props.setGiftListTransferenceStatementTab}
                              userEventThresholdGiftDetails={this.props.userEventThresholdGiftDetails}
                            />
                          : this.state.page === 2 ?
                            <VerificationForm
                              onBackClick={this.onBackClick}
                              isCombinadoExists={this.isCombinadoExists}
                              lables={this.props.lables}
                              user={this.props.user}
                              submitTransferenceData={this.state.submitTransferenceData}
                              transferenceData={transferenceData}
                              nextPage={this.nextPage}
                              setGiftListTransferenceStatementTab={this.props.setGiftListTransferenceStatementTab}
                              userEventThresholdGiftDetails={this.props.userEventThresholdGiftDetails}
                            />
                          : this.state.page === 3 ?
                            <OtpCode
                              eventId={this.eventId}
                              onBackClick={this.onBackClick}
                              user={this.props.user.data.result}
                              submitTransferenceData={this.state.submitTransferenceData}
                              lables={this.props.lables}
                              transferenceData={{ transferenceData: transferenceData.transferenceOptions,
                                isEmployee: transferenceData.isEmployee,
                                migratedEvent: transferenceData.migratedEvent,
                              }}
                              nextPage={this.nextPage}
                              type={'closure'}
                              setGiftListTransferenceStatementTab={this.props.setGiftListTransferenceStatementTab}
                              userEventThresholdGiftDetails={this.props.userEventThresholdGiftDetails}
                            />
                          : null
                        }
                      </React.Fragment>
                      :
                      <div className="col-xs-12">
                        <div className="col-xs-12" style={{ textAlign: 'center', marginTop: '5%' }}>
                          <InputButton buttonAttr={cerrarMesaSinOtp} />
                        </div>
                      </div>
                    :
                      <div className="col-xs-12">
                        {
                        this.state.transferenceDataError &&
                        this.state.transferenceDataError.indexOf('no purchased items') !== -1 ?
                          <React.Fragment>
                            <div className="col-xs-12" style={{ textAlign: 'center', marginTop: '5%' }}>
                              <InputButton buttonAttr={cerrarMesaSinOtp} />
                            </div>
                          </React.Fragment>
                        :
                         this.state.transferenceDataError ?
                          <div className="alertError" >
                            <i className="icon-tache2" />
                            <p>{this.state.transferenceDataError}</p>
                          </div> : null
                        }
                      </div>
                  }
                </div>
              :
                <>
                  <ApplyCSS pageName={pageName} />
                  <div className="closure-container">
                    <div className="row">
                      {
                      !_.isEmpty(transferenceData && this.props.user.data) ?
                      (transferenceData.transferenceOptions &&
                      (+transferenceData.transferenceOptions.bonusAmount > 0 || 
                      +transferenceData.transferenceOptions.transferableAmount > 0)
                      )
                       ?
                         <React.Fragment>
                           <div className="col-xs-12" style={{ width: '93%', margin: '0 4%' }}>
                             <MultiStepProgressBar
                               steps={3}
                               page={this.state.page}
                               stepsLabels={['Forma de depósito', 'Verificación de cierre',
                                 'Verificación de seguridad']}
                             />
                           </div>
                           <div className="col-xs-12">
                             {
                            this.state.page === 1 ?
                              <DepositForm
                                user={this.props.user}
                                submitTransferenceDataFunction={this.submitTransferenceDataFunction}
                                transference={transferenceData}
                                eventId={this.eventId}
                                lables={this.props.lables}
                                nextPage={this.nextPage}
                                type="closure"
                                setGiftListTransferenceStatementTab={this.props.setGiftListTransferenceStatementTab}
                                userEventThresholdGiftDetails={this.props.userEventThresholdGiftDetails}
                              />
                            :
                            this.state.page === 2 ?
                              <VerificationForm
                                onBackClick={this.onBackClick}
                                isCombinadoExists={this.isCombinadoExists}
                                lables={this.props.lables}
                                user={this.props.user}
                                submitTransferenceData={this.state.submitTransferenceData}
                                transferenceData={transferenceData}
                                nextPage={this.nextPage}
                                type="closure"
                                setGiftListTransferenceStatementTab={this.props.setGiftListTransferenceStatementTab}
                                userEventThresholdGiftDetails={this.props.userEventThresholdGiftDetails}
                              />
                            :
                            this.state.page === 3 ?
                              <OtpCode
                                eventId={this.eventId}
                                onBackClick={this.onBackClick}
                                user={this.props.user.data.result}
                                submitTransferenceData={this.state.submitTransferenceData}
                                lables={this.props.lables}
                                transferenceData={{ transferenceData: transferenceData.transferenceOptions,
                                  isEmployee: transferenceData.isEmployee,
                                  migratedEvent: transferenceData.migratedEvent,
                                }}
                                nextPage={this.nextPage}
                                type="closure"
                                setGiftListTransferenceStatementTab={this.props.setGiftListTransferenceStatementTab}
                                userEventThresholdGiftDetails={this.props.userEventThresholdGiftDetails}
                              />
                            : null
                          }
                           </div>
                         </React.Fragment>
                        :
                         <div className="col-xs-12">
                           <h3 style={{ paddingBottom: '2rem' }}>Cierre de mesa</h3>
                           <div className="col-xs-12" style={{ textAlign: 'center' }}>
                             <InputButton buttonAttr={cerrarMesaSinOtp} />
                           </div>
                         </div>
                      :
                         <div className="col-xs-12">
                           {
                        this.state.transferenceDataError &&
                        this.state.transferenceDataError.indexOf('no purchased items') !== -1 ?
                          <React.Fragment>
                            <h3 style={{ paddingBottom: '2rem' }}>Cierre de mesa</h3>
                            <div className="col-xs-12" style={{ textAlign: 'center' }}>
                              <InputButton buttonAttr={cerrarMesaSinOtp} />
                            </div>
                          </React.Fragment>
                        :
                         this.state.transferenceDataError ?
                          <div className="alertError">
                            <i className="icon-tache2" />
                            <p>{this.state.transferenceDataError}</p>
                          </div> : null
                        }
                         </div>
                    }

                    </div>
                  </div>
                </>
            }
          </div>
        : null}
      </React.Fragment>
    );
  }
}

const mapStateToProps = state => ({
  user: state.user,
  userEventThresholdGiftDetails: state.giftList.userEventThresholdGiftDetails,
});
const matchDispatchToProps = dispatch => bindActionCreators({ getEventSummaryInfo, getEventThresholdGiftDetails }, dispatch);
export default connect(mapStateToProps, matchDispatchToProps)(Closure);
